<template>
    <page :busy="busy" :tabs="tabs">
        <router-view class="travel-insurance"></router-view>
    </page>
</template>

<script>
    import mapSort from 'mapsort';
    import API from './../../api';
    import { mapActions, mapGetters } from 'vuex';
    import Page from '../generic/page/page.vue';

    export default {
        name: 'InsuranceList',
        components: {
            Page,
        },
        data() {
            return {
                basePath: '/app/travel-insurance',
                tabsToRender: [
                    {
                        title: 'Issuances',
                        route: '/app/travel-insurance/issuances',
                        active: false,
                    },
                    {
                        title: 'Setup',
                        route: '/app/travel-insurance/setup',
                        active: false,
                        disabled: false
                    },
                ],
                tabs: [],
                busy: false,
            };
        },
        watch: {
            metadata: {
                immediate: true,
                handler(md) {
                    const disabledTabs = ['Setup', ];
                    const hasSetupAccess =
                        this.metadata.permissions &&
                        this.metadata.permissions.has_setup_access;

                    this.tabsToRender.forEach(
                        tab =>
                            (tab.disabled =
                                !hasSetupAccess &&
                                disabledTabs.includes(tab.title))
                    );
                    this.setActiveTab(this.$route.path);
                },
            },                       
            $route(to, from) {
                this.setActiveTab(to.path);
            },
        },
        computed: {
            ...mapGetters('travelInsurance', ['metadata']),
        },                
        methods: {
            ...mapActions('travelInsurance', ['fetchStatus', 'fetchMetadata']),
            setActiveTab(path = '') {
                this.tabs = this.tabsToRender.filter(tab => !tab.disabled);
                if (this.isSetupActive(path)) {
                    this.tabs.forEach(
                        tab =>
                            (tab.active = tab.title === 'Setup' ? true : false)
                    );
                }
                if (this.isIssuancesActive(path)) {
                    this.tabs.forEach(
                        tab =>
                            (tab.active =
                                tab.title === 'Issuances' ? true : false)
                    );
                }
            },
            isSetupActive(path) {
                return path.indexOf(`${this.basePath}/setup`) != -1;
            },
            isIssuancesActive(path) {
                return path.indexOf(`${this.basePath}/issuances`) != -1;
            },
            async loadMetadata() {
                try {
                    this.busy = true;
                    await this.fetchMetadata();
                } catch (err) {
                    this.errorToast({text: `Could not load metadata.`})
                } finally {
                    this.busy = false;
                }
            },                       
        },
        mounted() {
            this.setActiveTab(this.$route.path);
        },
        beforeMount() {
            (async () => {
                this.loadMetadata();
            })();            
            (async () => {
                const loadStatusErrorMessage = `Could not load Travel Insurance status.`;
                this.busy = true;
                try {
                    await this.fetchStatus();
                } catch (e) {
                    this.errorToast({text: loadStatusErrorMessage})
                } finally {
                    this.busy = false;
                }
            })();
        },
    };
</script>

<style lang="scss" scoped>
    .travel-insurance {
        display: flex;
        flex-direction: column;
    }
</style>
